import { css } from 'styled-components';
import FormProStyle from "../templates/Form.style";
import FormBaseStyle from "../templates/FormBase.style";
import FromHzeroStyle from "../templates-hzero/Form.style";
var FormStyle = css(["", " ", ""], FormProStyle, FormBaseStyle);
var formData = {
  name: 'form',
  data: [{
    floatInputHeight: 48,
    floatTextHeight: 20
  }],
  onlyTemplate: [FormStyle, FromHzeroStyle]
};
export default formData;